module.exports = __webpack_public_path__ + "static/media/guide7.1e9d7cf1.png";